import React from "react";
import { LocationFields } from "./Fields";
import MultiForm from "./MultipleForm";

const LocationForms = () => {
  const addNewItem = React.useCallback((key) => {
    const fields = LocationFields(key);
    return { id: key, fields };
  }, []);

  return <MultiForm heading="location" addNewItem={addNewItem} />;
};

export default LocationForms;
